<nz-table
  #dynamicTable
  nzShowSizeChanger
  [nzData]="tableState.data"
  [nzLoading]="tableState.loading"
  [nzTotal]="tableState.totalCount"
  [nzPageSize]="tableState.pageSize"
  [nzPageIndex]="tableState.pageNumber"
  [nzFrontPagination]="false"
  [nzPageSizeOptions]="[10, 25, 50, 100, 200]"
  (nzQueryParams)="onQueryParamsChange($event)"
>
  <thead>
    <tr>
      @for (column of columns; track column) {
      <!-- Conditional th for search -->
      @if(column.search) { @if (column.sorting || column.sorting === undefined) {
      <th
        nzCustomFilter
        [nzColumnKey]="column.key"
        [nzSortFn]="true"
        [nzShowSort]="column.columnType !== EColumnTypeEnum.ACTION"
      >
        {{ column.title }}
        <nz-filter-trigger
          [nzActive]="!!searchValue[column.key] && searchValue[column.key].length > 0"
          [nzDropdownMenu]="menu"
        >
          <span nz-icon nzType="search" nzTheme="outline"></span>
        </nz-filter-trigger>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <div class="ant-table-filter-dropdown">
            <div class="search-box">
              <input
                type="text"
                nz-input
                [placeholder]="'shared.button.search' | translate"
                [(ngModel)]="searchValue[column.key]"
              />
              <button
                nz-button
                nzSize="small"
                nzType="primary"
                (click)="onQueryParamsChange($event, column.key)"
                class="search-button"
                >{{ "shared.button.search" | translate }}</button
              >
              <button nz-button nzSize="small" (click)="onQueryParamsChange($event, column.key, true)"
                >{{ "shared.button.reset" | translate }}</button
              >
            </div>
          </div>
        </nz-dropdown-menu>
      </th>
      } @if (!column.sorting && column.sorting !== undefined) {
      <th nzCustomFilter [nzColumnKey]="column.key">
        {{ column.title }}
        <nz-filter-trigger
          [nzActive]="!!searchValue[column.key] && searchValue[column.key].length > 0"
          [nzDropdownMenu]="menu"
        >
          <span nz-icon nzType="search" nzTheme="outline"></span>
        </nz-filter-trigger>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <div class="ant-table-filter-dropdown">
            <div class="search-box">
              <input
                type="text"
                nz-input
                [placeholder]="'shared.button.search' | translate"
                [(ngModel)]="searchValue[column.key]"
              />
              <button
                nz-button
                nzSize="small"
                nzType="primary"
                (click)="onQueryParamsChange($event, column.key)"
                class="search-button"
                >{{ "shared.button.search" | translate }}</button
              >
              <button nz-button nzSize="small" (click)="onQueryParamsChange($event, column.key, true)"
                >{{ "shared.button.reset" | translate }}</button
              >
            </div>
          </div>
        </nz-dropdown-menu>
      </th>
      } } @else { @if(column.filters && column.filters.length > 0) { @if (column.sorting || column.sorting ===
      undefined) {
      <th
        [nzColumnKey]="column.key"
        [nzSortFn]="true"
        [nzShowSort]="column.columnType !== EColumnTypeEnum.ACTION"
        [nzFilters]="column.filters || []"
        [nzFilterFn]="true"
        [nzFilterMultiple]="column.filterMultiple ?? false"
      >
        {{ column.title }}
      </th>
      } @if (!column.sorting && column.sorting !== undefined) {
      <th
        [nzColumnKey]="column.key"
        [nzFilters]="column.filters || []"
        [nzFilterFn]="true"
        [nzFilterMultiple]="column.filterMultiple ?? false"
      >
        {{ column.title }}
      </th>
      } } @else { @if(column.sorting || column.sorting === undefined) {
      <th [nzColumnKey]="column.key" [nzSortFn]="true" [nzShowSort]="column.columnType !== EColumnTypeEnum.ACTION">
        {{ column.title }}
      </th>
      } @if (!column.sorting && column.sorting !== undefined) {
      <th [nzColumnKey]="column.key"> {{ column.title }} </th>
      } } } }
    </tr>
  </thead>
  <tbody>
    @for(item of dynamicTable.data; track item) {
    <tr>
      @for(column of columns; track column) {
      <td>
        @if(column.columnType === EColumnTypeEnum.IMAGE) {
        <img nz-image class="image" [nzSrc]="getItemValue(item, column.key)" alt="'Image preview'" />

        } @else if (column.columnType === EColumnTypeEnum.BOOLEAN_BADGE) {
        <nz-badge [nzStatus]="getItemValue(item, column.key)"></nz-badge>} @else { @if (column.columnType !==
        EColumnTypeEnum.ACTION) {<span>{{ getItemValue(item, column.key) }}</span>} @if (column.columnType ===
        EColumnTypeEnum.ACTION) { @for (action of column.possibleActions; track action) { @if (action ===
        EPossibleActionsEnum.EDIT) {
        <button nz-button nzType="link" (click)="triggerAction(EPossibleActionsEnum.EDIT, item)">
          <span nz-icon nzType="edit"></span>
        </button>
        } @if (action === EPossibleActionsEnum.DELETE && setDeleteActionPerUserRole(item, action)) {
        <button
          nz-button
          nzType="link"
          nz-popconfirm
          nzPopconfirmTitle="{{ 'shared.warning.areYouSure' | translate }}"
          (nzOnConfirm)="triggerAction(EPossibleActionsEnum.DELETE, item)"
        >
          <span nz-icon nzType="delete"></span>
        </button>
        } @if (action === EPossibleActionsEnum.VIEW) {
        <button nz-button nzType="link" (click)="triggerAction(EPossibleActionsEnum.VIEW, item)">
          <span nz-icon nzType="arrow-right"></span>
        </button>
        } @if (action === EPossibleActionsEnum.RESET_PASSWORD) {
        <button nz-button nzType="link" (click)="triggerAction(EPossibleActionsEnum.RESET_PASSWORD, item)">
          <span nz-icon nzType="lock"></span>
        </button>
        } } } }
      </td>
      }
    </tr>
    }
  </tbody>
</nz-table>
